import { Link } from "react-router-dom";

const ServiceItems = ({ id, items }) => (
  <div className="grid grid-cols-3 2xl:grid-cols-4 gap-6">
    {items.length > 0 ? (
      items.map((item) =>
        item && item.name ? (
          <Link
            key={item.id}
            to={`/quan-ly-khach-hang/${id}/tao-moi/${item.formName}/${item.id}`}
            className="bg-white shadow rounded-lg p-4 flex flex-col items-center justify-start hover:bg-blue-100"
          >
            <img
              src="/images/document-sign.png"
              alt="icon"
              className="w-12 h-12 mb-2"
            />
            <p className="text-center text-sm font-medium line-clamp-2">
              {item.name}
            </p>
          </Link>
        ) : (
          <div key={item.id || Math.random()} className="text-red-500">
            Dữ liệu không hợp lệ
          </div>
        )
      )
    ) : (
      <div className="col-span-6 text-center text-gray-500">
        Không có dịch vụ nào để hiển thị
      </div>
    )}
  </div>
);

export default ServiceItems;
